/**
 * Liveness toasts: GET /api/live (DEX) + GET /api/platform/live (CEX) — same stack as CEX actions.
 * Module state avoids duplicate toasts under React 18 StrictMode (remount).
 */

import { useEffect } from 'react'
import { useAuth } from '../contexts/AuthContext.jsx'
import { useCexToast } from '../contexts/CexToastContext.jsx'
import { usePlatform } from '../contexts/PlatformContext.jsx'
import { logsHostMode } from '../lib/apiBase.js'

/** @type {{ dex: boolean | null, cex: boolean | null }} */
let _lastPlatformHealth = { dex: null, cex: null }
/** Sticky across remounts: session had anonymous → logged-in edge */
let _moduleHadUser = false

/**
 * Renders null; only side effects.
 */
export function PlatformConnectionToasts() {
  const { user } = useAuth()
  const { health } = usePlatform()
  const { showError, showSuccess } = useCexToast()

  useEffect(() => {
    if (!user) {
      _lastPlatformHealth = { dex: health.dex, cex: health.cex }
      _moduleHadUser = false
      return
    }
    if (!_moduleHadUser) {
      _moduleHadUser = true
      _lastPlatformHealth = { dex: null, cex: null }
    }
    const mode = logsHostMode()
    const sides = mode === 'both' ? ['dex', 'cex'] : mode === 'dex' ? ['dex'] : ['cex']
    for (const side of ['dex', 'cex']) {
      const v = health[side]
      const pv = _lastPlatformHealth[side]
      if (v === pv) continue
      if (!sides.includes(side)) continue
      if (v === true) {
        showSuccess(
          side === 'dex' ? 'GET /api/live — ok' : 'GET /api/platform/live — ok',
          side,
        )
      } else if (v === false) {
        showError(
          side === 'dex' ? 'GET /api/live — failed' : 'GET /api/platform/live — failed',
          side,
        )
      }
    }
    _lastPlatformHealth = { dex: health.dex, cex: health.cex }
  }, [user, health, showError, showSuccess])

  return null
}
